import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const Button = ({ title, Icon, selected, size, onClick = () => {} }) => (
    <div className="sidebar-btn-container" onClick={onClick}>
        <div className={`sidebar-btn-indicator ${selected && 'sidebar-btn-indicator--selected'}`} />
        <div className="sidebar-btn-contents">
            <Icon className={`sidebar-btn-icon ${selected && 'sidebar-btn-icon--selected'} ${title.toLowerCase()}`} size={size ? size : ''} />
            <p className={selected ? 'sidebar-selected-text' : undefined}>{title}</p>
        </div>
    </div>
)

Button.propTypes = {
    title: PropTypes.string.isRequired,
    selected: PropTypes.bool,
}

export default Button
